import { fluid } from '@helpers/fluid';
import { paragraphMedium, paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
const Loader = styled.div `
  position: relative;
  display: flex;
  background: var(--bgColour);
  color: var(--fgColour);
  flex-direction: column;
  height: 100%;
  place-content: center;
  place-items: center;
  text-align: center;
  width: 100%;
  z-index: 999;

  &[data-layout='inline'] {
    padding: ${fluid(48, 96)};
  }

  &[data-layout='absolute'] {
    position: absolute;
    top: 0;
    left: 0;
  }

  &[data-layout='fixed'] {
    position: fixed;
    top: 0;
    left: 0;
  }

  &[data-alignment='top'] {
    place-content: flex-start;
    padding-top: 24px;
  }
`;
const LoaderText = styled.span `
  ${paragraphMedium};

  display: block;
  margin: 1rem 0 0;
`;
const AdditionalMessage = styled.span `
  ${paragraphSmall};

  display: block;
  max-width: 420px;
  margin: 8px 0 0;
`;
const LoadingIndicatorStyles = {
    Loader,
    LoaderText,
    AdditionalMessage,
};
export default LoadingIndicatorStyles;
